import React from 'react';

import { ImapInboxMail } from 'jamespot-user-api';
import { CSSMailItemWrapper, CSSMailItemHref } from './styles';

import { WidgetEmailsItemHeader } from './components/WidgetEmailsItemHeader';
import { WidgetEmailsItemSubject } from './components/WidgetEmailsItemSubject';
import { WidgetEmailsItemBody } from './components/WidgetEmailsItemBody';
import { WidgetEmailsItemFooter } from './components/WidgetEmailsItemFooter';

export type JRCWidgetEmailsImapProps = { emailList: ImapInboxMail[] };

export const JRCWidgetEmailsImap = ({ emailList }: JRCWidgetEmailsImapProps) => {
    return (
        <>
            {emailList.map((email, index) => {
                return (
                    <CSSMailItemWrapper key={index} read={email.read}>
                        <WidgetEmailsItemHeader read={email.read} fromName={email.fromName} date={email.date} />
                        <WidgetEmailsItemSubject subject={email.subject} read={email.read} />
                        <WidgetEmailsItemBody text={email.body} read={email.read} />
                        <WidgetEmailsItemFooter count={email.attachmentsCount} />
                        <CSSMailItemHref
                            href={email.url ?? undefined}
                            target="_blank"
                            rel="noreferrer"></CSSMailItemHref>
                    </CSSMailItemWrapper>
                );
            })}
        </>
    );
};
